import React from 'react';
import PropTypes from 'prop-types';
import Landing from '../../components/StudentPlatform/pages/Landing';

const LandingContainer = ({ companyName, customContent }) => {
  return <Landing companyName={companyName} customContent={customContent} />;
};

LandingContainer.propTypes = {
  companyName: PropTypes.string,
  customContent: PropTypes.string,
};

export default LandingContainer;


